/** Constantes do financeiro v2 (contas, situação dos lançamentos, origem). */

export const FINANCE_ACCOUNT_TYPES = ['cash', 'bank', 'digital_wallet', 'credit_card', 'other'] as const;
export type FinanceAccountTypeKey = (typeof FINANCE_ACCOUNT_TYPES)[number];

export const FINANCE_ACCOUNT_TYPE_LABELS: Record<FinanceAccountTypeKey, string> = {
  cash: 'Dinheiro (caixa)',
  bank: 'Conta bancária',
  digital_wallet: 'Carteira digital',
  credit_card: 'Cartão de crédito',
  other: 'Outra',
};

/** Nome da conta que toda loja ganha ao começar a usar o financeiro. */
export const DEFAULT_CASH_ACCOUNT_NAME = 'Caixa da loja';

/** Situação exibida de um lançamento, calculada no fuso da loja. */
export const ENTRY_DISPLAY_STATUSES = ['pending', 'due_today', 'overdue', 'paid', 'canceled'] as const;
export type EntryDisplayStatus = (typeof ENTRY_DISPLAY_STATUSES)[number];

export const ENTRY_DISPLAY_STATUS_LABELS: Record<EntryDisplayStatus, string> = {
  pending: 'A vencer',
  due_today: 'Vence hoje',
  overdue: 'Vencido',
  paid: 'Pago',
  canceled: 'Cancelado',
};

/** Filtro de situação da lista: `pending` = todos em aberto (inclui vencidos e de hoje). */
export const ENTRY_STATUS_FILTERS = ['pending', 'upcoming', 'due_today', 'overdue', 'paid', 'canceled'] as const;
export type EntryStatusFilter = (typeof ENTRY_STATUS_FILTERS)[number];

/** De onde o lançamento veio. */
export const ENTRY_ORIGINS = ['manual', 'recurrence', 'purchase', 'order', 'charge', 'transfer'] as const;
export type EntryOrigin = (typeof ENTRY_ORIGINS)[number];

export const ENTRY_ORIGIN_LABELS: Record<EntryOrigin, string> = {
  manual: 'Lançado à mão',
  recurrence: 'Despesa ou receita fixa',
  purchase: 'Compra de mercadoria',
  order: 'Venda (devolução)',
  charge: 'Pagamento online',
  transfer: 'Transferência entre contas',
};

/** Data usada no filtro de período da lista. */
export const ENTRY_DATE_FIELDS = ['due', 'paid', 'competence'] as const;
export type EntryDateField = (typeof ENTRY_DATE_FIELDS)[number];

export const ENTRY_DATE_FIELD_LABELS: Record<EntryDateField, string> = {
  due: 'Vencimento',
  paid: 'Pagamento',
  competence: 'Competência',
};

export const STATEMENT_LINE_STATUSES = ['pending', 'matched', 'created', 'ignored'] as const;
export type StatementLineStatusKey = (typeof STATEMENT_LINE_STATUSES)[number];

export const STATEMENT_LINE_STATUS_LABELS: Record<StatementLineStatusKey, string> = {
  pending: 'A conciliar',
  matched: 'Conciliada',
  created: 'Lançada pelo extrato',
  ignored: 'Ignorada',
};

/** Projeções do fluxo de caixa disponíveis (dias). */
export const CASHFLOW_HORIZONS = [30, 60, 90] as const;

/** Horizonte da geração das despesas e receitas fixas (dias a partir de hoje). */
export const RECURRENCE_HORIZON_DAYS = 45;
